import React from 'react'

const RightPage4 = () => {
   const skills = [
  { name: "LT Spice", percent: 100 },
  { name: "Cad", percent: 90 },
  { name: "Matlab", percent: 75 },
  { name: " Project Management", percent: 80 },
  { name: " Electronics", percent: 90 },
  { name: "C/C++", percent: 55 },
];



    return (
    <div>
      <section className="bg-gray-50 py-12 px-6">
      <h2 className="text-3xl font-bold mb-2">Skills</h2>
      <div className="w-16 h-1 bg-blue-500 mb-6"></div>
      <p className="text-gray-600 mb-8">
        We have the skills and experience to deliver great results.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {skills.map((skill, index) => (
          <div key={index}>
            <div className="flex justify-between mb-1">
              <span className="font-semibold">{skill.name}</span>
              <span className="text-sm font-semibold">{skill.percent}%</span>
            </div>
            <div className="w-full bg-gray-300 rounded h-2">
              <div
                className="bg-blue-500 h-2 rounded"
                style={{ width: `${skill.percent}%` }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </section>
    </div>
  )
}

export default RightPage4
